export default {"src":"/_next/static/media/case-study-icon.27ac2dad.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};